// Central content file — edit here to update the landing page.
export const site = {
  brand: {
    name: "DSS",
    longName: "Dynamic Strategic Solutions",
    tagline: "Building Businesses. Empowering People. Creating Legacy.",
    website: "www.dssgroup.co.za",
    websiteUrl: "https://www.dssgroup.co.za",
  },
  nav: [
    { label: "Businesses", href: "#businesses" },
    { label: "Journey", href: "#journey" },
    { label: "Focus", href: "#focus" },
    { label: "People", href: "#people" },
    { label: "Partner", href: "#partner" },
    { label: "Contact", href: "#contact" },
  ],
  hero: {
    overline: "Diversified Business Group",
    headingLine1: "Growing Today.",
    headingLine2: "Building Tomorrow.",
    subheading:
      "Strategic Thinking. Operational Excellence. Sustainable Growth — across fuel, retail, logistics and hospitality.",
    ctaPrimary: "Partner With Us",
    ctaSecondary: "Explore Our Businesses",
    imageUrl:
      "https://images.unsplash.com/photo-1523477593243-78bbf626fd3b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  },
  stats: [
    { value: "100+", label: "Employees" },
    { value: "2", label: "Strategic Locations" },
    { value: "5", label: "Business Units" },
    { value: "20+", label: "Years of Growth" },
  ],
  businesses: [
    {
      key: "fuel",
      title: "Fuel Retail",
      description:
        "Delivering quality fuel and exceptional service at prime locations.",
      image:
        "https://images.unsplash.com/photo-1565043666747-69f6646db940?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      icon: "Fuel",
    },
    {
      key: "convenience",
      title: "Convenience Retail",
      description:
        "Café 365 — customer-focused retail offering everyday essentials and more.",
      image:
        "https://images.unsplash.com/photo-1689037676470-b72230d5236e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      icon: "ShoppingBag",
    },
    {
      key: "gas",
      title: "LP Gas Distribution",
      description:
        "Safe, reliable and efficient gas solutions for homes and businesses.",
      image:
        "https://images.pexels.com/photos/17109813/pexels-photo-17109813.jpeg?auto=compress&cs=tinysrgb&w=1600",
      icon: "Flame",
    },
    {
      key: "logistics",
      title: "Logistics & Distribution",
      description:
        "Integrated logistics services ensuring timely and efficient deliveries.",
      image:
        "https://images.unsplash.com/photo-1616432043562-3671ea2e5242?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      icon: "Truck",
    },
    {
      key: "hospitality",
      title: "Hospitality",
      description:
        "Parkwood Boutique Guest House — comfortable stays, memorable experiences, warm hospitality.",
      image:
        "https://images.unsplash.com/photo-1602081115720-72e5b0a254b8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      icon: "BedDouble",
    },
  ],
  journey: [
    {
      year: "2005",
      title: "Foundation",
      description: "Acquired Service Station, Midrand.",
    },
    {
      year: "2008 – 2016",
      title: "Expansion",
      description: "Expanded retail services, car wash, and LP Gas operations.",
    },
    {
      year: "2016 – 2020",
      title: "Logistics Era",
      description:
        "Grew logistics capabilities and built strong operational systems.",
    },
    {
      year: "2021",
      title: "Acquisition",
      description: "Acquired Modderfontein Service Station.",
    },
    {
      year: "2025",
      title: "Hospitality",
      description: "Launched Parkwood Boutique Guest House.",
    },
    {
      year: "2026 & Beyond",
      title: "Limitless Growth",
      description: "New opportunities. New partnerships. Limitless growth.",
    },
  ],
  focus: [
    {
      title: "Property Development",
      description:
        "Unlocking value through strategic property investments and developments.",
      icon: "Building2",
    },
    {
      title: "Hospitality Growth",
      description:
        "Expanding our hospitality footprint and creating unique guest experiences.",
      icon: "BedDouble",
    },
    {
      title: "Logistics Expansion",
      description:
        "Scaling operations to deliver greater reach, efficiency and reliability.",
      icon: "Truck",
    },
    {
      title: "Digital Platforms",
      description:
        "Leveraging technology to enhance customer experience and drive growth.",
      icon: "Smartphone",
    },
    {
      title: "Sustainability",
      description:
        "Building sustainable businesses that create long-term value for people and the planet.",
      icon: "Leaf",
    },
    {
      title: "Strategic Partnerships",
      description:
        "Collaborating with trusted partners to unlock new opportunities.",
      icon: "Handshake",
    },
  ],
  people: {
    title: "Our People. Our Strength.",
    description:
      "We believe our people are our greatest asset. We invest in talent, encourage growth, and create an environment where everyone can thrive.",
    bullets: [
      "Continuous learning & development",
      "Leadership & mentorship",
      "Career growth & advancement",
      "A culture of respect, integrity & teamwork",
      "A safe, inclusive & empowering workplace",
    ],
    image:
      "https://images.unsplash.com/photo-1573167507387-6b4b98cb7c13?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  },
  careers: {
    title: "Careers at DSS",
    description: "Build your future with a company that builds success.",
    bullets: [
      "Exciting career opportunities",
      "Structured training programs",
      "Clear growth paths",
      "Competitive benefits",
      "Work with purpose",
    ],
  },
  partner: {
    title: "Why Partner with DSS?",
    bullets: [
      "Proven track record",
      "Diverse & complementary businesses",
      "Strong operational excellence",
      "Financial discipline & sustainability",
      "Long-term value creation",
      "Integrity, transparency & accountability",
    ],
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  },
  lookingAhead: {
    title: "Looking Ahead",
    description:
      "Our vision is bold. Our plans are clear. Our commitment is unwavering.",
    statement: "We are building a legacy that empowers generations.",
    pillars: [
      { label: "More Opportunities", icon: "Star" },
      { label: "More Impact", icon: "Target" },
      { label: "More Success", icon: "Trophy" },
    ],
  },
  finalCta: {
    overline: "Let's build something extraordinary together.",
    headingLine1: "Join Us.",
    headingLine2: "Build With Us.",
    headingLine3: "Grow With Us.",
    description:
      "Whether you are an investor, partner, customer or future team member — there is a place for you in our journey.",
    ctaPrimary: "Get In Touch",
    ctaSecondary: "Explore Careers",
  },
  contact: {
    emailGeneral: "solutions@mydss.co.za",
    emailCareers: "hr@mydss.co.za",
    phone: "072 474 7477",
    address: "Midrand, South Africa",
  },
};
